import type { CalculatePriceMultiRoutesAPI } from '@hero/api';
import type { Order, VehicleTypes } from '@hero/schema';
import { fromOrderAgainSource } from '../order-draft/adapters/fromOrder';
import { buildDraftPriceCalcRequest } from '../pricing/buildDraftPriceCalcRequest';

export type ReorderPriceCalcOverrides = {
  vehicleType?: VehicleTypes;
  vehicleCount?: number;
};

/**
 * Thin wrapper: hydrates party + lane context from the source order
 * via `fromOrderAgainSource`, then delegates to
 * {@link buildDraftPriceCalcRequest}.
 */
export function buildReorderPriceCalcRequest(
  order: Order,
  orgId: string | undefined,
  overrides: ReorderPriceCalcOverrides = {},
): CalculatePriceMultiRoutesAPI['req'] | null {
  const hydration = fromOrderAgainSource(order);
  const origin = hydration.origin;
  if (!origin) return null;

  const vehicleCount = overrides.vehicleCount ?? hydration.destinationVehicleQuantities[0] ?? 1;

  return buildDraftPriceCalcRequest({
    orgId,
    customerId: hydration.customer?.customerId,
    isInternalShipment: hydration.isInternalShipment,
    origin: { lat: origin.lat, lng: origin.lng },
    destinations: hydration.destinations.map((d, idx) => ({
      lat: d.lat,
      lng: d.lng,
      quantity: idx === 0 ? vehicleCount : undefined,
    })),
    vehicleType:
      overrides.vehicleType ??
      hydration.load.vehicleType ??
      hydration.load.vehicleTypes?.[0],
    requirePartyContext: !hydration.isInternalShipment,
  });
}
